import { render, staticRenderFns } from "./TabBox.vue?vue&type=template&id=0f460c15&scoped=true&"
import script from "./TabBox.vue?vue&type=script&lang=ts&"
export * from "./TabBox.vue?vue&type=script&lang=ts&"
import style0 from "./TabBox.vue?vue&type=style&index=0&id=0f460c15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f460c15",
  null
  
)

export default component.exports